import { isPlatformBrowser } from '@angular/common'
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  makeStateKey,
  PLATFORM_ID,
  provideEnvironmentInitializer,
  TransferState,
} from '@angular/core'
import { CLIENT_CONFIG_ENV_KEY, ClientConfig } from '@pai/commons'

import { CLIENT_CONFIG } from './client-config.token'

const clientConfigDataKey = makeStateKey<ClientConfig>('clientConfig')

export function provideClientConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: CLIENT_CONFIG,
      useFactory: () => {
        // we cannot use the logger here. logger depends on CLIENT_CONFIG --> circular dependency

        if (isPlatformBrowser(inject(PLATFORM_ID))) {
          const clientConfig = inject(TransferState).get(clientConfigDataKey, void 0)
          if (!clientConfig) {
            throw new Error('CLIENT_CONFIG not set in TransferState')
          }
          return clientConfig
        } else {
          // in SSR we get the config from the environment
          const clientConfig = JSON.parse(process.env[CLIENT_CONFIG_ENV_KEY] ?? 'null') as ClientConfig
          if (!clientConfig) {
            throw new Error('CLIENT_CONFIG not set in environment')
          }
          inject(TransferState).set(clientConfigDataKey, clientConfig)
          return clientConfig
        }
      },
    },
    // ensure it is used at least once in SSR otherwise it won't be put to TransferState
    provideEnvironmentInitializer(() => inject(CLIENT_CONFIG)),
  ])
}
